import moment from 'moment-timezone';

export function setDefaultTimezone(timezone) {
  moment.tz.setDefault(timezone);
}

const timeZone = localStorage.getItem('timeZone') || 'Europe/Madrid';
setDefaultTimezone(timeZone);
